<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    placeholder="No filter"
    @change="handleInput"
  >
    <option
      v-for="option in options"
      :value="option.value"
      :key="option.value"
    >{{ option.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterExistStrategies",
  props: {
    label: {
      type: String,
      default: "Exit Strategy"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].exitStrategies;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "exitStrategies",
          value
        ]);
      }
    },
    options() {
      return [
        { value: 0, label: 'All strategies' },
        ...this.$store.state.enums.exitStrategyEnum
      ];
    },
    text() {
      if (this.filterValue) {
        let strategy = this.$store.state.enums.exitStrategyEnum.find(strategy => strategy.value === this.filterValue);
        return "Only " + strategy.label + " Strategies";
      } else {
        return null;
      }
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
